import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { mediaQuery } from '@savgroup-front-common/core/grid/helpers';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $DeliveredSparePartIconAndText = styled.div`
  display: flex;
  align-items: center;
`;

export const $DeliveredSparePartIconAndTextMessage = styled.span`
  margin-left: ${spacing('lg')};
  margin-right: ${spacing('lg')};
`;

export const $DeliveredSparePartColWithPaddingTopForXs = styled.div`
  @media ${media.minWidth.sm} {
    margin-bottom: ${spacing('sm')};
  }
`;

export const $DeliveredSparePartColAlignCenter = styled(Col)`
  display: flex;
  align-items: center;
  min-width: 175px;
  color: ${({ theme }) => theme.colors.success};

  ${mediaQuery.xs`
    justify-content: center;
    margin-top: ${spacing('md')};
    width: 100%;
  `}

  ${mediaQuery.sm`
    justify-content: center;
    margin-top: 0;
    width: auto;
  `}
`;

export const $DeliveredSparePartActionButtonWrapper = styled(Col)`
  display: flex;
  justify-content: flex-end;
  min-width: 175px;

  ${mediaQuery.xs`
    justify-content: center;
    margin-top: ${spacing('md')};
  `}
`;

export const $DeliveredSparePartActionButton = styled(Button)`
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.lightGrey : theme.colors.primary};
  color: ${({ theme, disabled }) =>
    disabled ? theme.colors.black : theme.colors.white};
  padding: ${spacing('sm')} ${spacing('xxl')};
  height: auto;

  &:active,
  &:focus,
  &:active:hover,
  &:hover {
    background-color: ${({ theme, disabled }) =>
      disabled ? theme.colors.lightGrey : theme.colors.primaryHover};
    color: ${({ theme, disabled }) =>
      disabled ? theme.colors.black : theme.colors.white};
  }

  ${mediaQuery.xs`
    width: 100%;
  `}
`;

export const $DeliveredSparePart = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing('lg')};
  align-items: center;
  justify-content: space-between;

  @media ${media.maxWidth.sm} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    & > * {
      width: 100%;
    }
  }
`;
